import styled from "@rentiohq/shared-frontend/dist/components/theme/styled-components";
import { centerFormWrap } from "../../../../utils/styles.utils";

export const FormWrap = styled.div`
  ${centerFormWrap}
`;

export const ButtonInfo = styled.div`
  margin-right: 4px;
  font-size: 15px;
  color: ${props => props.theme.colors.neutral1};
  > * {
    float: left;
    margin: 0;
  }
`;
